import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LuUserRound } from 'react-icons/lu';

const Dashboard = () => {
    const { t } = useTranslation();
    return (
        <Link
            to="/dashboard"
            className="flex items-center px-2 py-1 gap-2 text-sm rounded transition-all"
            inactiveProps={{ className: 'text-white hover:bg-white hover:text-[#1e2b43]' }}
            activeProps={{ className: 'bg-white text-[#1e2b43]' }}
        >
            <>
                <LuUserRound />
                <span>{t('TOP_HEADER.NAV_BAR.DASHBOARD')}</span>
            </>
        </Link>
    );
};

export default Dashboard;
